import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Components/Context/AuthContext";

const BLOCKED_ALLOWED_ROUTES = [
  "/supplier-penalties",
  "/buyer-penalties",
  "/account",
  "/wallet",
  "/",
  "/contact-us",
  "/terms-and-conditions",
  "/privacy-policy",
  "/refund-policy",
];

const UserProtectedRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // If user account access is blocked due to unpaid penalties, restrict operational routes
  if (
    user?.isAppAccessBlocked &&
    !BLOCKED_ALLOWED_ROUTES.some((r) =>
      r === "/" ? location.pathname === "/" : location.pathname.startsWith(r)
    )
  ) {
    if (user?.role === "supplier") {
      return <Navigate to="/supplier-penalties" replace />;
    }
    return <Navigate to="/buyer-penalties" replace />;
  }

  return children;
};

export default UserProtectedRoute;
